// extracted by mini-css-extract-plugin
export default {"emphasis":"App_emphasis__1XT+7","container":"App_container__4L7Vo","sso":"App_sso__vm-P5"};